import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: ${tokens.spacing.horizontalSmall} ${tokens.spacing.verticalMedium};
  justify-content: space-between;
  flex-grow: 1;
  border-radius: ${tokens.radius.medium};
  min-width: 229px;
  gap: ${tokens.spacing.horizontalMedium};
  background-color: ${tokens.colors.dark1};

  > button {
    border-color: ${tokens.colors.dark5};
  }
`

export const InfoContainer = styled.div`
  width: 141px;
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.verticalXsmall};
`

export const UserInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.verticalXsmall};
`

export const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 42px;
  gap: ${tokens.spacing.horizontalXsmall};
`

export const ContentName = styled.span`
  max-width: 110px;
  font-size: ${tokens.fontSize.small};
  font-weight: ${tokens.fontWeights.regular};
  line-height: ${tokens.lineHeight.medium}%;
  color: ${tokens.colors.dark6};
`

export const CardTitle = styled.span`
  font-size: ${tokens.fontSize.small};
  font-weight: ${tokens.fontWeights.bold};
  line-height: ${tokens.lineHeight.medium}%;
  color: ${tokens.colors.dark6};
`
